/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";

import { useGoogleAnalytics } from "volto-google-analytics";
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Quick links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about">About us</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/the-team">The team</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/contact-us">
                        Contact us
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
                <List>
                  <List.Header>
                    <h4>News & Updates</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news">
                        Latest articles
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="https://2e3b6c78.sibforms.com/serve/MUIFAF7lIdkhPUw7XM1uRNa5IwIZM0zZJYTJe4x8b2v5HfPOrZGuWGYXtxChIqOQIoKi2zt4LijGf4kytxtf35G6QL20_xFZroB_BY5K55kfu8YDH07kUdipbcUOZfC2O_qVrxtujIucXPHRRUPp3A9v4mEXrtrAiQulLWY7uBxgs74QvLhOFKuzy8gzVutiYxnfBfXYo4C_C64a">
                        Mailing List
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={5} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Programs</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/programs/africa2moon">
                        Africa2Moon
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/africa-first">
                        Africa FIRST
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/data-for-disaster-management">
                        Data for Disaster Management
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/geomagnetic-solar-climate-model-gmsc">
                        Geomagnetic Solar Climate Model (GMSC)
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/african-astronaut-programme">
                        African Astronaut Programme
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/space-resources">
                        Space Resources
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/education-platform-and-capacity-building">
                        Education Platform and Capacity Building
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/programs/economic-modelling-framework">
                        Economic Modelling Framework
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn
                width={2}
                textAlign="left"
                className="columnborder"
              ></GridColumn>
              <GridColumn width={3} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://www.instagram.com/africa2moon"
                            target="_blank"
                            title="Instagram"
                          >
                            <i class="bi bi-instagram"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/profile.php?id=61571387170454"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://x.com/developspacesa"
                            target="_blank"
                            title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/foundation-for-space-development-africa/"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i class="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/@Africa2Moon"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.tiktok.com/@africa2moon"
                            target="_blank"
                            title="TikTok"
                          >
                            <i class="bi bi-tiktok"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Foundation for Space Development Africa {current_year}"
                        defaultMessage="{copyright} Foundation for Space Development Africa {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of{" "}
                      <a href="https://nasa.gov" target="_blank">
                        NASA
                      </a>
                      ,{" "}
                      <a href="https://www.pexels.com" target="_blank">
                        Pexels
                      </a>{" "}
                      &{" "}
                      <a href="https://unsplash.com" target="_blank">
                        Unsplash
                      </a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-square"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
